const API_URL = 'https://rt.anthonybois.fr/backend/api';

// Fonction utilitaire pour obtenir les headers avec le token
const getHeaders = () => {
    const token = localStorage.getItem('token');
    console.log('Token récupéré:', token); // Debug

    const headers = {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
    };
    
    console.log('Headers envoyés:', headers); // Debug
    return headers;
};

const getToken = () => localStorage.getItem('token');

export const loginUser = async (email, password) => {
    try {
        const response = await fetch(`${API_URL}/users/login.php`, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ email, password })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response.json();
    } catch (error) {
        console.error('Erreur login:', error);
        throw error;
    }
};

export const registerUser = async (email, password) => {
    try {
        const response = await fetch(`${API_URL}/users/register.php`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, password }),
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Erreur lors de l\'inscription');
        }

        return await response.json();
    } catch (error) {
        console.error('Erreur lors de l\'inscription:', error);
        throw error;
    }
};

export const getRoadtrips = async () => {
    try {
        const token = getToken();
        const response = await fetch(`${API_URL}/roadtrips/list.php?token=${token}`, {
            method: 'GET',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Accept': 'application/json'
            }
        });
        
        if (!response.ok) {
            const error = await response.json();
            if (error.message === 'Token invalide') {
                localStorage.removeItem('token');
                window.location.href = '/login';
                return;
            }
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Erreur getRoadtrips:', error);
        throw error;
    }
};

export const getRoadtripById = async (id, sharedToken) => {
    try {
        const token = getToken();
        const response = await fetch(`${API_URL}/roadtrips/get.php?id=${id}&token=${token}${sharedToken ? `&sharedToken=${sharedToken}` : ''}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        });
        
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Erreur getRoadtripDetails:', error);
        throw error;
    }
};

export const createRoadtrip = async (formData) => {
    try {
        const token = getToken();
        
        // Transformer les données pour correspondre au format attendu par le backend
        const roadtripData = {
            roadtrip_name: formData.name,
            description: formData.description,
            roadtrip_status: formData.status,
            date_depart_prevu: formData.dates?.[0] || null,
            date_fin_prevu: formData.dates?.[1] || null,
            etapes: formData.gpxFiles?.map(file => file.name) || []
        };

        const response = await fetch(`${API_URL}/roadtrips/create.php?token=${token}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(roadtripData)
        });
        
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Erreur lors de la création du roadtrip');
        }
        
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Erreur createRoadtrip:', error);
        throw error;
    }
};

export const addTravel = async (roadtripId, formData) => {
    try {
        const token = getToken();
        const response = await fetch(`${API_URL}/roadtrips/add_travel.php?token=${token}&roadtrip_id=${roadtripId}`, {
            method: 'POST',
            body: formData // FormData contenant le fichier GPX et les infos
        });
        
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Erreur lors de l\'ajout du travel');
        }
        
        return await response.json();
    } catch (error) {
        console.error('Erreur addTravel:', error);
        throw error;
    }
};

export const updateRoadtrip = async (roadtripId, updatedData) => {
    try {
        const token = getToken();
        const response = await fetch(`${API_URL}/roadtrips/update.php?token=${token}&roadtrip_id=${roadtripId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(updatedData)
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Erreur lors de la mise à jour du roadtrip');
        }

        return await response.json();
    } catch (error) {
        console.error('Erreur updateRoadtrip:', error);
        throw error;
    }
};

export const shareRoadtrip = async (roadtripId, email, isReadOnly) => {
    try {
        const token = getToken();
        const response = await fetch(`${API_URL}/roadtrips/share.php?token=${token}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ roadtrip_id: roadtripId, email, is_read_only: isReadOnly })
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Erreur lors du partage du roadtrip');
        }

        return await response.json();
    } catch (error) {
        console.error('Erreur shareRoadtrip:', error);
        throw error;
    }
};

export const deleteRoadtrip = async (roadtripId) => {
    try {
        const token = getToken();
        const response = await fetch(`${API_URL}/roadtrips/delete.php?token=${token}&roadtrip_id=${roadtripId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Erreur lors de la suppression du roadtrip');
        }

        return await response.json();
    } catch (error) {
        console.error('Erreur deleteRoadtrip:', error);
        throw error;
    }
};